import { UnifiedAuthRequest } from '@ul/api';

const checkCaptcha = (authRequest: UnifiedAuthRequest) => {
    return !!authRequest.email.includes('captcha');
};

const hasCaptcha = (authRequest: UnifiedAuthRequest) => {
    return !!authRequest.captchaVerifyInfo?.captchaResult;
};

const checkSignup = (authRequest: UnifiedAuthRequest) => {
    return !!authRequest.signupInfo?.firstName && authRequest.signupInfo?.lastName;
};

const hasOtp = (authRequest: UnifiedAuthRequest) => {
    return !!authRequest.otpVerifyInfo?.code;
};

const hasSocialConsent = (authRequest: UnifiedAuthRequest) => {
    return authRequest?.socialConsentApproved;
};

export { checkCaptcha, hasCaptcha, checkSignup, hasOtp, hasSocialConsent };
